import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/user";
import Button from "@/atomic/atoms/Button";

const inputBase =
  "w-full h-14 px-4 rounded-xl border font-primary text-base text-text bg-white placeholder:text-tertiary " +
  "focus:outline-none focus:ring-0 focus:border-primary border-border";

export default function RegisterView({
  goBack,
  user,
  onChange,
  goToPin,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Recibos" hasLeftButton goBack={goBack} />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <article className="w-full max-w-[480px] px-6 pt-6 pb-8 flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0 overflow-y-auto pb-4">
            <h2 className="text-text text-[22px] leading-tight font-primary font-semibold tracking-tight">
              Validar acesso
            </h2>
            <p className="text-tertiary text-sm font-primary mt-1">
              Precisamos validar seus dados de acesso, informe abaixo o CPF
              usado para os pagamentos.
            </p>

            <div className="mt-6 flex flex-col gap-5">
              <div>
                <label className="block text-sm font-primary text-text mb-2">
                  CPF
                </label>
                <InputMask
                  value={user?.document as string}
                  name="document"
                  required
                  onChange={onChange}
                  type="text"
                  inputMode="numeric"
                  mask="___.___.___-__"
                  replacement={{ _: /\d/ }}
                  placeholder="CPF"
                  className={inputBase}
                />
              </div>
            </div>
          </div>

          <div className="mt-8 shrink-0">
            <Button
              className="rounded-theme-large bg-primary text-white font-primary font-semibold border-0"
              title="Avançar"
              onClick={goToPin}
              type="submit"
              isDisabled={isDisabled}
            />
          </div>
        </article>
      </main>
    </div>
  );
}
